<template>
  <transition name="fade">
    <div class="flex flex-col items-center justify-center absolute w-full h-full pin-y pin-l z-1010 bg-overlay">
      <div class="w-5/6 lg:w-1/4 rounded bg-white relative">
        <div class="absolute pin-t pin-r mr-2 mt-2 cursor-pointer" @click="close">
          <v-icon scale="1" class="self-center" name="times" color="#6f6f70" />
        </div>
        <div class="m-4">
          <h3 class="text-grey-darkest text-sm">Info</h3>
          <div class="flex">
            <div class="flex-1 text-grey-darker text-sm mt-2">
              Aplikasi ini merupakan sebuah upaya untuk
              menyajikan informasi terkait pemenuhan kebutuhan
              guru dan tenaga pengajar di Indonesia.
              <br>
              <br>
              &copy; Kemendikbud 2019
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  TOGGLE_MODAL_ABOUT
} from '@/mutationTypes'

export default {
  name: 'modal-about',
  methods: {
    close () {
      this.$store.dispatch(TOGGLE_MODAL_ABOUT, false)
    }
  }
}
</script>
